import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private analytics: any;
  private readonly maxWaitTimeMs = 15000; // 15 seconds
  private readonly pollIntervalMs = 100; // 0.1 seconds
  private readonly initiWaitForAnalytics: Promise<void>;

  public constructor() {
    this.initiWaitForAnalytics = this.waitForAnalytics();
  }

  public async trackPage(pageName: string, properties?: Record<string, any>) {
    await this.initiWaitForAnalytics;
    if (this.analytics) {
      try {
        await this.analytics.page(pageName, properties);
      } catch (error) {
        console.warn('Analytics page tracking error:', error);
      }
    }
  }

  public async trackEvent(eventName: string, properties?: Record<string, any>) {
    await this.initiWaitForAnalytics;
    if (this.analytics) {
      try {
        await this.analytics.track(eventName, properties);
      } catch (error) {
        console.warn('Analytics event tracking error:', error);
      }
    }
  }

  public async identifyAuth0User(auth0User: any) {
    await this.initiWaitForAnalytics;
    if (this.analytics) {
      try {
        await this.analytics.identifyAuth0User(auth0User);
      } catch (error) {
        console.warn('Analytics user identification error:', error);
      }
    }
  }

  public async reset() {
    await this.initiWaitForAnalytics;
    if (this.analytics) {
      try {
        await this.analytics.reset();
      } catch (error) {
        console.warn('Analytics reset error:', error);
      }
    }
  }

  private async waitForAnalytics() {
    const startTime = Date.now();

    while (!(window as any)['LfxAnalytics']?.['LfxSegmentsAnalytics']) {
      if (Date.now() - startTime > this.maxWaitTimeMs) {
        console.warn('Analytics script failed to load within timeout period. Analytics tracking will be disabled.');
        return;
      }
      // The loop pauses for 100ms between each check so it only checks ~10 times per second
      await new Promise((resolve) => setTimeout(resolve, this.pollIntervalMs));
    }

    try {
      this.analytics = (window as any)['LfxAnalytics']['LfxSegmentsAnalytics'].getInstance();
      await this.analytics.init();
    } catch (error) {
      console.error('Failed to initialize analytics:', error);
      this.analytics = null;
    }
  }
}
